
import { chatApi, subscribeToMessages } from "../chatApiService";
import { targetService } from "../targetService";
import { targetNotesService } from "../targetNotesService";

export class ChatService {
  // Session management
  static async getSessions() {
    return await chatApi.getSessions();
  }

  static async createSession(title?: string) {
    return await chatApi.createSession(title);
  }

  static async getMessages(sessionId: string) {
    return await chatApi.getMessages(sessionId);
  }

  static async sendMessage(sessionId: string, content: string, fileUrls?: string[]) {
    return await chatApi.sendMessage(sessionId, content, fileUrls);
  }

  // Real-time subscriptions
  static subscribeToMessages(sessionId: string, onNewMessage: (message: any) => void) {
    return subscribeToMessages(sessionId, onNewMessage);
  }

  // Target management
  static async getTargetBySession(sessionId: string) {
    return await targetService.getTargetBySession(sessionId);
  }

  // Notes management
  static async storeNote(targetCode: string, sessionId: string, noteType: 'text' | 'image', content: string) {
    return await targetNotesService.storeNote(targetCode, sessionId, noteType, content);
  }
}
